module.exports = __webpack_public_path__ + "img/member_title.d563328b.png";